import { ReloadIcon } from '@radix-ui/react-icons';
import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

const loadingVariants = cva('inline-block animate-spin', {
  variants: {
    size: {
      xs: 'h-3 w-3',
      sm: 'h-4 w-4',
      md: 'h-6 w-6',
      lg: 'h-8 w-8',
    },
    type: {
      inline: '',
      section: 'h-full w-full flex items-center justify-center',
    },
  },
  defaultVariants: {
    size: 'md',
    type: 'inline',
  },
});

interface LoadingProps extends VariantProps<typeof loadingVariants> {
  type?: 'section' | 'inline';
}

export const Loading: React.FC<LoadingProps & React.ComponentProps<typeof ReloadIcon>> = ({ size, type = 'inline', ...props }) => {
  const icon = <ReloadIcon className={loadingVariants({ size })} {...props} />;

  if (type === 'section') {
    return <div className={loadingVariants({ type })}>{icon}</div>;
  }

  return icon;
};
